import { createStore } from 'owa-satcheljs';
import type { OcpsPolicyStoreState } from './schema/OcpsPolicyStore';
import { OcpsStoreState } from './schema/OcpsPolicyStore';

const defaultStore: OcpsPolicyStoreState = {
    state: OcpsStoreState.ReadyToFetch,
};

const defaultExport: () => OcpsPolicyStoreState = createStore('ocpsPolicyStore', defaultStore);
export default defaultExport;
